<template>
  <div class="admin">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Admin</h1>
        </div>
      </div>
    </div>
    <div class="container">
      <br/>
      <br/>
      <br/>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'admin',
    components : {
    },
    computed: {
    },
    data () {
        return {
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            publicPath: process.env.BASE_URL,
        }
    },
    methods:{
        isAdmin() {
          return this.$parent.isAdmin();
        }
    },
    mounted(){
      if (this.isAdmin()) {
        //
      } else {
        alert("You don't have permission to access this page.");
      }
    }
}
</script>

<style lang="scss" scoped>
  .hero {
    background-color: black;
  }
  .box {
    font-family: Verdana;
  }
  .admin {
  }
</style>